/* ============================================================
   DOOFINDER-STYLE FULLSCREEN SEARCH  (assets/df-search.js)
   - Opens when the header search is clicked
   - Live product results via /search/suggest.json
   - Latest searches saved in localStorage
   - Popular searches + recommended collection set in
     Theme settings > "Fullscreen Search"
   ============================================================ */
(function () {
  var overlay = document.getElementById('dfOverlay');
  if (!overlay) return;

  var input = document.getElementById('dfInput');
  var grid = document.getElementById('dfGrid');
  var title = document.getElementById('dfResultsTitle');
  var viewAll = document.getElementById('dfViewAll');
  var recentWrap = document.getElementById('dfRecentWrap');
  var recentChips = document.getElementById('dfRecentChips');
  var popularList = document.getElementById('dfPopularList');
  var sliderWrap = document.getElementById('dfSliderWrap');
  var CUR = overlay.dataset.currency || '£';
  var COLLECTION = overlay.dataset.collection || 'best-seller';
  var LS_KEY = 'df_recent_searches';
  var debounceTimer = null;
  var recommendedCache = null;
  var catalogPromise = null;

  function getCatalog() {
    if (catalogPromise) return catalogPromise;
    catalogPromise = (function fetchPage(page, acc) {
      return fetch('/products.json?limit=250&page=' + page)
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (data) {
          var items = data.products || [];
          acc = acc.concat(items);
          if (items.length === 250 && page < 4) return fetchPage(page + 1, acc);
          return acc.map(function (p) {
            return {
              title: p.title,
              url: '/products/' + p.handle,
              image: (p.images && p.images[0] && p.images[0].src) || '',
              price: p.variants && p.variants[0] && p.variants[0].price,
              _search: (p.title + ' ' + (p.product_type || '') + ' ' + (p.tags || []).join(' ')).toLowerCase()
            };
          });
        })
        .catch(function () { return []; });
    })(1, []);
    return catalogPromise;
  }

  /* ---------- open / close ---------- */
  function open() {
    overlay.classList.add('is-open');
    document.body.classList.add('df-lock');
    renderRecent();
    if (!input.value.trim()) showRecommended();
    setTimeout(function () { input.focus(); }, 50);
  }

  function close() {
    overlay.classList.remove('is-open');
    document.body.classList.remove('df-lock');
  }

  document.getElementById('dfClose').addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
  });

  /* intercept clicks on the header search (input, icon, or modal trigger) */
  var TRIGGERS = [
    '.search-modal__form input', '.header__search input', 'input[name="q"]',
    '.header__icon--search', '.quickSearch', '[data-header-search]',
    'details-modal.header__search', '.search-modal'
  ].join(',');

  document.addEventListener('click', function (e) {
    var hit = e.target.closest(TRIGGERS);
    if (!hit) return;
    /* ignore clicks inside our own overlay */
    if (overlay.contains(e.target)) return;
    /* only the HEADER search opens the overlay - the search results
       page has its own q input which must keep working normally */
    if (!hit.closest('header, .header-navigation, .section-header-navigation, .header-nav-multi-site, .header-mobile, .site-header, [id*="header" i], [class*="section-header"]')) return;
    e.preventDefault();
    e.stopPropagation();
    open();
  }, true);

  /* ---------- latest searches (localStorage) ---------- */
  function getRecent() {
    try { return JSON.parse(localStorage.getItem(LS_KEY) || '[]'); }
    catch (err) { return []; }
  }

  function saveRecent(q) {
    q = q.trim();
    if (!q) return;
    var list = getRecent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
    list.unshift(q);
    localStorage.setItem(LS_KEY, JSON.stringify(list.slice(0, 8)));
  }

  function renderRecent() {
    var list = getRecent();
    recentChips.innerHTML = '';
    recentWrap.hidden = list.length === 0;
    list.forEach(function (q) {
      var chip = document.createElement('span');
      chip.className = 'df-chip';
      var label = document.createElement('span');
      label.textContent = q;
      var x = document.createElement('span');
      x.className = 'x';
      x.textContent = '\u00d7';
      x.addEventListener('click', function (e) {
        e.stopPropagation();
        localStorage.setItem(LS_KEY, JSON.stringify(getRecent().filter(function (v) { return v !== q; })));
        renderRecent();
      });
      chip.appendChild(label);
      chip.appendChild(x);
      chip.addEventListener('click', function () {
        input.value = q;
        doSearch(q);
      });
      recentChips.appendChild(chip);
    });
  }

  document.getElementById('dfRecentClear').addEventListener('click', function () {
    localStorage.removeItem(LS_KEY);
    renderRecent();
  });

  /* ---------- popular searches (theme setting) ---------- */
  (overlay.dataset.popular || '').split(',').forEach(function (term) {
    term = term.trim();
    if (!term) return;
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.textContent = term;
    a.addEventListener('click', function () {
      input.value = term;
      doSearch(term);
    });
    li.appendChild(a);
    popularList.appendChild(li);
  });

  /* ---------- product cards ---------- */
  function money(p) {
    if (p === null || p === undefined || p === '') return '';
    var n = parseFloat(p);
    if (isNaN(n)) return '';
    return CUR + n.toFixed(2);
  }

  function card(p) {
    var a = document.createElement('a');
    a.className = 'df-card';
    a.href = p.url;
    var img = document.createElement('img');
    img.loading = 'lazy';
    img.src = p.image || '';
    img.alt = p.title;
    var t = document.createElement('div');
    t.className = 'df-card__title';
    t.textContent = p.title;
    var pr = document.createElement('div');
    pr.className = 'df-card__price';
    pr.textContent = money(p.price);
    a.appendChild(img);
    a.appendChild(t);
    a.appendChild(pr);
    return a;
  }

  function setSlider(on) {
    if (sliderWrap) sliderWrap.classList.toggle('is-slider', !!on);
  }

  function renderProducts(list, emptyMsg) {
    grid.innerHTML = '';
    if (!list.length) {
      var d = document.createElement('div');
      d.className = 'df-empty';
      d.textContent = emptyMsg || 'No products found.';
      grid.appendChild(d);
      return;
    }
    list.forEach(function (p) { grid.appendChild(card(p)); });
  }

  /* ---------- recommended products (collection) ---------- */
  function mapProducts(data) {
    return (data.products || []).map(function (p) {
      return {
        title: p.title,
        url: '/products/' + p.handle,
        image: (p.images && p.images[0] && p.images[0].src) || '',
        price: p.variants && p.variants[0] && p.variants[0].price
      };
    });
  }

  function shuffle(a) {
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  function showRecommended() {
    title.textContent = 'Recommended products';
    viewAll.hidden = true;
    setSlider(true);
    if (recommendedCache) { renderProducts(recommendedCache); return; }
    fetch('/collections/' + encodeURIComponent(COLLECTION) + '/products.json?limit=12')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (data) {
        var items = mapProducts(data);
        if (items.length) {
          recommendedCache = items;
          renderProducts(items);
          return;
        }
        /* collection empty or missing: fall back to random store products */
        return fetch('/products.json?limit=24')
          .then(function (r) { return r.ok ? r.json() : { products: [] }; })
          .then(function (all) {
            recommendedCache = shuffle(mapProducts(all)).slice(0, 12);
            renderProducts(recommendedCache, 'No products available yet.');
          });
      })
      .catch(function () { renderProducts([], 'No products available yet.'); });
  }

  /* slider arrows */
  (function () {
    var prev = document.getElementById('dfPrev');
    var next = document.getElementById('dfNext');
    if (!prev || !next) return;
    function step() { return Math.max(grid.clientWidth * 0.8, 240); }
    prev.addEventListener('click', function () { grid.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { grid.scrollBy({ left: step(), behavior: 'smooth' }); });
  })();

  /* ---------- live search ---------- */
  function doSearch(q) {
    q = q.trim();
    if (q.length < 2) { showRecommended(); return; }
    setSlider(false);
    title.textContent = 'Results for "' + q + '"';
    var suggest = fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        return (((data.resources || {}).results || {}).products || []).map(function (p) {
          return {
            title: p.title,
            url: p.url,
            image: (p.featured_image && p.featured_image.url) || p.image || '',
            price: p.price
          };
        });
      })
      .catch(function () { return []; });

    Promise.all([suggest, getCatalog()]).then(function (res) {
      /* only respond to the latest typed query */
      if (input.value.trim() !== q) return;
      var items = res[0] || [];
      var seen = {};
      items.forEach(function (m) { seen[m.url.split('?')[0]] = 1; });
      var ql = q.toLowerCase();
      (res[1] || []).forEach(function (m) {
        if (seen[m.url]) return;
        if (m._search.indexOf(ql) !== -1) {
          seen[m.url] = 1;
          items.push(m);
        }
      });
      renderProducts(items.slice(0, 48), 'No products found for "' + q + '".');
      viewAll.hidden = items.length === 0;
      viewAll.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
      saveRecent(q);
      renderRecent();
    });
  }

  input.addEventListener('input', function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () { doSearch(input.value); }, 250);
  });

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && input.value.trim().length >= 2) {
      saveRecent(input.value);
      window.location.href = '/search?q=' + encodeURIComponent(input.value.trim()) + '&type=product';
    }
  });
})();
